export default __webpack_public_path__ + "static/media/portfolio-181.693be7bc.jpg";